import { useMutation, useQueryClient } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import { teamsQueryKeys } from "./queryKeyFactory";
import type { TeamFilters, TeamListItem } from "../types/teams.types";

type UpdateTeamFiltersMutationPayload = {
    teamId: number;
    queryFilters: TeamFilters;
};

export const useUpdateTeamFiltersMutation = () => {
    const queryClient = useQueryClient();

    return useMutation<void, Error, UpdateTeamFiltersMutationPayload>({
        mutationFn: ({ teamId, queryFilters }) => salesApiService.teams.updateTeamFilters(teamId, { queryFilters }),
        onSuccess: (_data, { teamId, queryFilters }) => {
            queryClient.setQueryData<TeamListItem[]>(teamsQueryKeys.all(), (teams) =>
                teams?.map((team) => (team.teamId === teamId ? { ...team, filters: queryFilters } : team)),
            );
            void queryClient.invalidateQueries({ queryKey: teamsQueryKeys.all(), exact: true });
        },
    });
};
